import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type { ContentPublisherOut } from '@/api/generated/schemas';
import { Provider } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { PublisherShowHeader } from '@/components/content_catalog/publishers/PublisherShowHeader';
import { PublisherGeneralTab } from '@/components/content_catalog/publishers/PublisherGeneralTab';
import { PublisherContractsTab } from '@/components/content_catalog/publishers/PublisherContractsTab';
import { PublisherIntegrationTab } from '@/components/content_catalog/publishers/PublisherIntegrationTab';
import {
  CONTENT_PUBLISHER_DEFAULT_TAB,
  CONTENT_PUBLISHER_SHOW_TABS,
} from './constants';

export const ContentCatalogPublisherShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<ContentPublisherOut>({
    resource: 'content_catalog.publishers',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('content_catalog.publishers', record?.name);

  // Only Novelist publishers deliver on their own; Elibri ones come through the feed.
  const tabs = CONTENT_PUBLISHER_SHOW_TABS.filter(
    (tab) => tab !== 'integration' || record?.provider === Provider.novelist
  );
  const [activeTab, onTabChange] = useShowTab(
    tabs,
    CONTENT_PUBLISHER_DEFAULT_TAB
  );

  return (
    <Show
      isLoading={isLoading}
      canEdit={false}
      contentProps={bareShowContentProps}
    >
      {record && (
        <>
          <PublisherShowHeader
            record={record}
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && <PublisherGeneralTab record={record} />}
            {activeTab === 'contracts' && (
              <PublisherContractsTab
                publisherId={record.id}
                publisherFetchedAt={query.dataUpdatedAt}
                onChanged={() => query.refetch()}
              />
            )}
            {activeTab === 'integration' && (
              <PublisherIntegrationTab
                publisherId={record.id}
                publisherFetchedAt={query.dataUpdatedAt}
              />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
